/* @flow */
// typecheck: ignore file
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Text from 'components/Text.jsx';
import type { GlyphName } from '@remind/r101-glyphs';

import './styles/FormNote.scss';

type Props = {
  glyph?: ?GlyphName,
  glyphColor?: string,
  children?: ?any,
};

class FormNote extends React.Component {
  props: Props;

  render() {
    let glyph;

    if (this.props.glyph) {
      glyph = (
        <Glyph
          name={this.props.glyph}
          color={this.props.glyphColor || 'inherit'}
          size="medium"
          className="FormNote-glyph"
        />
      );
    }

    return (
      <MediaObject gutter="small" className="FormNote">
        {glyph}
        <Text size="xxsmall" weight="semibold">
          {this.props.children}
        </Text>
      </MediaObject>
    );
  }
}

export default FormNote;



// WEBPACK FOOTER //
// ./src/components/FormNote.jsx